jQuery(function() {

  var text = window.ppt.translate(
      'cookieconsent.description',
      'Um die Nutzung der Webseite für Sie optimal zu gestalten und sie fortlaufend verbessern zu können, verwenden wir Cookies. In unserer <a aria-label="learn more about cookies" role="button" tabindex="0" class="cc-link" href="/datenschutzerklaerung/" target="_blank">Datenschutzerklärung</a> erfahren Sie mehr über die Verwendung und den Zweck der Cookies.'
  );
  var acceptText = window.ppt.translate('cookieconsent.accept','Akzeptieren');
  var declineText = window.ppt.translate('cookieconsent.decline','Nicht akzeptieren');

  var template = `<div role="dialog" aria-live="polite" aria-label="cookieconsent" aria-describedby="cookieconsent:desc" class="row cc-window cc-banner cc-type-info cc-theme-block cc-bottom cc-color-override--2052982713 " style="">
        <!--googleoff: all-->
        <span id="cookieconsent:desc" class="cc-message columns large-8 medium-12">
            ${text}
        </span>        
        <div class="cc-compliance columns large-4 medium-12">
            <a aria-label="dismiss cookie message" role="button" tabindex="0" class="cc-btn cc-not-accept">${declineText}</a> 
            <a aria-label="dismiss cookie message" role="button" tabindex="0" class="cc-btn cc-dismiss">${acceptText}</a>                       
        </div>
        <!--googleon: all-->
    </div>`;

  var privateFunctions = {
      setCookie(name, value, days){
          if(window.pixelpoint.utilities.isIframe()){
            window.parent.postMessage({
                event_id:"setCookie",
                data:{
                    name:name,
                    value:value,
                    days:days
                }
            },"*");
          }
          else{
              window.setCookie(name, value,days);
          }
      },
    eraseCookie(name){
        if(window.pixelpoint.utilities.isIframe()){
            window.parent.postMessage({
                event_id:"eraseCookie",
                data:{
                    name:name
                }
            },"*");
          }
          else{
              window.eraseCookie(name);
          }
    },
    readCookie(name){
        if(window.pixelpoint.utilities.isIframe()){
            return window.location.href.indexOf(`${name}=1`) !== -1 ? 1 : 0;    
        }
        else{
            return readCookie(name);
        }
    },
    reloadWindow(){
        if(window.pixelpoint.utilities.isIframe()){
            window.parent.postMessage({
                event_id:"reloadWindow"
            },"*");
        }
        else{
            window.location.reload();   
        } 
    }
  }
//*
  if (!privateFunctions.readCookie("pp_cookie_consent_set") && !window.pixelpoint.utilities.isIframe() && !window.cmp_id) {
    $("body").append(template);
    $("body").on("click touchstart", ".cc-compliance .cc-dismiss", function() {
    
      window.pixelpoint.tagManager.event("accepting cookies",{});
    
      $(".cc-window").fadeOut();
      privateFunctions.setCookie("pp_cookie_consent_set", "1", 365);

      var analyticsCookieAllowed =
        privateFunctions.readCookie("pp_allow_analytics_cookies") || 1;
      var thirdPartyCookieAllowed =
        privateFunctions.readCookie("pp_allow_third_party_cookies") || 1;

      var anythingChanged = false;
      if (
        !privateFunctions.readCookie("pp_allow_analytics_cookies") ||
        !privateFunctions.readCookie("pp_allow_third_party_cookies")
      ) {
        anythingChanged = true;
      }
      privateFunctions.setCookie("pp_allow_analytics_cookies", analyticsCookieAllowed, 365);
      privateFunctions.setCookie("pp_allow_third_party_cookies", thirdPartyCookieAllowed, 365);
      window.pixelpoint.ga.enable();
      window.pixelpoint.tagManager.event("Cookies wurden akzeptiert");

      //console.log(dataLayer);

      if (anythingChanged) {
          setTimeout(function(){
            privateFunctions.reloadWindow(); 
          },500);              
      }
    });
    $("body").on("click touchstart", ".cc-compliance .cc-not-accept", function() {
      //if the visitor does not agree with cookies we have to delete the cookies

      window.pixelpoint.tagManager.event("not accepting cookies",{});
      var anythingChanged = false;
      $(".cc-window").fadeOut();
      //window.setCookie("pp_cookie_consent_set", "1", 365);
      if (
        !!readCookie("pp_allow_analytics_cookies") ||
        !!readCookie("pp_allow_third_party_cookies")
      ) {
        anythingChanged = true;
      }
      eraseCookie("pp_allow_analytics_cookies");
      eraseCookie("pp_allow_third_party_cookies");

      window.pixelpoint.tagManager.event("Cookies wurden nicht akzeptiert");

      window.pixelpoint.ga.disable();
      //if (anythingChanged) {
        privateFunctions.reloadWindow();
      //}
    });
  }

  $("body").on("click touchstart","#save-analytics-cookies",function(e){
       e.preventDefault();
        var allowCookies = $("#cc-analytics-cookies").is(":checked");
        if(allowCookies){
            privateFunctions.setCookie("pp_allow_analytics_cookies", "1", 365);
            window.pixelpoint.ga.enable();
            window.pixelpoint.modal.open("Sie haben diese Cookies erfolgreich aktiviert");      
        }
        else{
            privateFunctions.eraseCookie("pp_allow_analytics_cookies");
            window.pixelpoint.ga.disable();
            window.pixelpoint.modal.open("Sie haben diese Cookies erfolgreich deaktiviert");
        }
        window.pixelpoint.tagManager.event("changed analytics cookies",{"allow":allowCookies});
  });
  $("body").on("click touchstart","#save-third-party-cookies",function(e){
        e.preventDefault();
        var allowCookies = $("#cc-third-party-cookies").is(":checked");
        if(allowCookies){
            privateFunctions.setCookie("pp_allow_third_party_cookies", "1", 365);
            window.pixelpoint.modal.open("Sie haben diese Cookies erfolgreich aktiviert");             
        }
        else{
            privateFunctions.eraseCookie("pp_allow_third_party_cookies");
            document.cookie = 'pp_allow_third_party_cookies=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;';
            window.pixelpoint.modal.open("Sie haben diese Cookies erfolgreich deaktiviert");
        }
        window.pixelpoint.tagManager.event("changed third-party cookies",{"allow":allowCookies});
  });
        if($("#cc-analytics-cookies").length > 0){
            if(!privateFunctions.readCookie("pp_allow_analytics_cookies")){
                $("#cc-analytics-cookies").prop("checked",false);
            }
            else{
                $("#cc-analytics-cookies").prop("checked",true);
            }
        }
        if($("#cc-third-party-cookies").length > 0){
            if(!privateFunctions.readCookie("pp_allow_third_party_cookies")){
                $("#cc-third-party-cookies").prop("checked",false);
            }
            else{
                $("#cc-third-party-cookies").prop("checked",true);
            }
        }
        //*/
});
